import React, { useState } from 'react'
import '../styles/Card.css'
import texts from '../texts'

const Card = ({ hiragana, romaji, subcat, onAnswer, darkMode = false }) => {
  const [flipped, setFlipped] = useState(false)

  const handleFlip = () => setFlipped(!flipped)

  const handleAnswer = (isCorrect) => {
    onAnswer(isCorrect)
    setFlipped(false)
  }

  const handleSpeak = () => {
    if ('speechSynthesis' in window) {
      // Elimina todo lo que esté entre paréntesis (incluidos los paréntesis)
      const cleanText = romaji.replace(/\s*\(.*?\)/g, '')
      const utter = new window.SpeechSynthesisUtterance(cleanText)
      utter.lang = 'ja-JP'
      utter.voice = speechSynthesis
        .getVoices()
        .find((v) => v.lang === 'ja-JP' && v.name.includes('Kyoko'))
      utter.rate = 0.8
      window.speechSynthesis.speak(utter)
    }
  }

  return (
    <div className={`card ${flipped ? 'flipped' : ''}`} onClick={handleFlip}>
      {!flipped ? (
        <div className='card-front'>
          {subcat && <div className='card-category'>Categoría: {subcat}</div>}
          <span>{hiragana}</span>
        </div>
      ) : (
        <div className='card-back' onClick={(e) => e.stopPropagation()}>
          <div className='card-romaji-container'>
            <p className='romaji'>{romaji}</p>
          </div>
          <br />
          <div className='buttons'>
            <button
              onClick={(e) => {
                e.stopPropagation()
                handleAnswer(true)
              }}
            >
              {texts.card.correct}
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation()
                handleAnswer(false)
              }}
            >
              {texts.card.incorrect}
            </button>
          </div>
          <button
            type='button'
            onClick={(e) => {
              e.stopPropagation()
              handleSpeak()
            }}
            className={`card-listen-button ${darkMode ? 'dark-mode' : 'light-mode'}`}
            title='Escuchar pronunciación'
          >
            <svg width='50' height='50' viewBox='0 0 24 24' fill='currentColor'>
              <path d='M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.26 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' />
            </svg>
          </button>
        </div>
      )}
    </div>
  )
}

export default Card
